import React, { useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { getOrders } from "./redux/actions/orders";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieChart() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const { orders } = useSelector((state) => state.orders);

  const data = {
    labels: [
      "Fives",
      "Tens",
      "Fifteens",
      "Twenty Fives",
      "Fifties",
      "Hundreds",
    ],
    datasets: [
      {
        label: "# of Votes",
        data: [
          orders
            .map((order) => parseInt(order.attributes.fives))
            .reduce((a, b) => a + b, 0),
          orders
            .map((order) => parseInt(order.attributes.tens))
            .reduce((a, b) => a + b, 0),
          orders
            .map((order) => parseInt(order.attributes.fifteens))
            .reduce((a, b) => a + b, 0),
          orders
            .map((order) => parseInt(order.attributes.twenty_fives))
            .reduce((a, b) => a + b, 0),
          orders
            .map((order) => parseInt(order.attributes.fifties))
            .reduce((a, b) => a + b, 0),
          orders
            .map((order) => parseInt(order.attributes.hundreds))
            .reduce((a, b) => a + b, 0),
        ],
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
        weight: 3,
      },
    ],
  };

  return (
    <Pie
      data={data}
      options={{
        responsive: true,
        maintainAspectRatio: true,
      }}
    />
  );
}
